import React, { Component } from 'react'
import PropTypes from "prop-types";
import BaseConnectMessage from './BaseConnectMessage';
import BaseMessageLayout from './BaseMessageLayout';

class ConnectMessage extends Component {
    static  propTypes ={
        idconversation: PropTypes.number,
        textmessage: PropTypes.string,
        resource: PropTypes.string,
        type: PropTypes.string,
        messagedate: PropTypes.string,
        originusermessage:PropTypes.string,
        username:PropTypes.string,
        name:PropTypes.string,
        mail:PropTypes.string,
        inc:PropTypes.string,
        phonenumber:PropTypes.string,

    }

    render() {
        const { idconversation, textmessage, resource, type, messagedate, hours, minutes, username, originusermessage,name, mail, inc, phonenumber} = this.props
        return (
            <BaseMessageLayout
                messagedate={messagedate}
                hours={hours}
                minutes={minutes}
                resource={resource}
                type={type}
                originname={this.props.originname}
                displayoriginname={this.props.displayoriginname}
                >
                    <BaseConnectMessage
                        name={name}
                        mail={mail}
                        inc={inc}
                        phonenumber={phonenumber}
                    />            
            </BaseMessageLayout>
        )
    }
}

export default ConnectMessage
